/**
 * Mutation hook for the anonymous public period-inquiry endpoint
 * (`/public/offers/:token/period-inquiry`). Goes through `callPublic`, so it never carries a
 * session. No query invalidation: the inquiry is fire-and-forget, like the SSO
 * `useSubmitPeriodInquiry`.
 */
import { useMutation } from '@tanstack/react-query';
import { publicOfferLink } from '@ooh/contracts';
import type { OfferPeriodInquiryUnitSelection } from '@ooh/contracts';
import { useApiClient } from '../../plugs/api-client';

export interface PublicSubmitPeriodInquiryVars {
  selection: OfferPeriodInquiryUnitSelection[];
}

export function usePublicSubmitPeriodInquiry(token: string) {
  const api = useApiClient();
  return useMutation({
    mutationFn: ({ selection }: PublicSubmitPeriodInquiryVars) =>
      api.callPublic(publicOfferLink.publicSubmitPeriodInquiry, { token, selection }),
  });
}
